import React from 'react';

import { Box, makeStyles } from '@material-ui/core';
import { ActionButton, KlpModal, Typography } from '@klp/design';
import {
    customApiSelectors,
    setRemoteSessionExpired,
} from '@klp/core/api/store';
import { useDispatch, useSelector } from 'react-redux';
import { useAuth, storeReferrer } from '@klpkonsern/auth-core';

const useStyles = makeStyles((theme) => ({
    button: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: theme.spacing(2),
    },
}));

export const SessionExpiryModal: React.FC = () => {
    const { login } = useAuth();
    const { remoteSessionExpired } = useSelector(customApiSelectors);
    const dispatch = useDispatch();
    const classes = useStyles();

    const handleLogin = () => {
        storeReferrer();
        dispatch(setRemoteSessionExpired(false));
        login();
    };
    return (
        <KlpModal
            isOpen={remoteSessionExpired}
            onClose={handleLogin}
            translation="auth.sessionTimeout"
        >
            <Typography translation="auth.sessionTimeoutLoginAgain" />
            <Box className={classes.button}>
                <ActionButton
                    actionType="button"
                    onClick={handleLogin}
                    translation="general.close"
                />
            </Box>
        </KlpModal>
    );
};
